import { AppDialog } from "@/design/AppDialog";
import { Button } from "@/design/Button";

/**
 * The three account-security moments, designed and worded here so production
 * wiring is judgment-free. Tone: protective and warm, never accusatory.
 */

/** Starting playback while another device holds the family stream. */
export function StreamTakeoverDialog({
  visible,
  activeDeviceLabel,
  onWatchHere,
  onCancel
}: {
  visible: boolean;
  activeDeviceLabel: string | null;
  onWatchHere: () => void;
  onCancel: () => void;
}) {
  return (
    <AppDialog
      visible={visible}
      title="Already watching on another device"
      body={`Your family account is watching ${activeDeviceLabel ? `on your ${activeDeviceLabel}` : "on another device"} right now. You can stop that session and continue here.`}
      onRequestClose={onCancel}
      actions={
        <>
          <Button label="Not now" variant="ghost" onPress={onCancel} />
          <Button label="Watch here instead" onPress={onWatchHere} />
        </>
      }
    />
  );
}

/** New device, but the family account already has 3 activated. */
export function DeviceLimitDialog({
  visible,
  onManageDevices,
  onClose
}: {
  visible: boolean;
  onManageDevices: () => void;
  onClose: () => void;
}) {
  return (
    <AppDialog
      visible={visible}
      title="This account is on 3 devices"
      body="Your family account can watch on up to 3 devices. To watch here, remove one you no longer use from your account settings."
      onRequestClose={onClose}
      actions={
        <>
          <Button label="Not now" variant="ghost" onPress={onClose} />
          <Button label="Manage devices" onPress={onManageDevices} />
        </>
      }
    />
  );
}
